import { makeStyles } from "@material-ui/core/styles";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import { UserView } from "@saleor/products/customTypes/UserView";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    dropdown: {
      display: "flex",
      flexGrow: 0,
      marginLeft: theme.spacing(3)
    },
    dropdownWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: theme.spacing(3)
    }
  }),
  { name: "DropdownWrapper" }
);

interface ProductKAMSDropdownGroupProps {
  brand: string;
  brandChoices: SingleAutocompleteChoiceType[];
  brandLabel: string;
  brandDisabled?: boolean;
  onBrandChange: (e) => void;
  userView: string;
  userViewChoices: UserView[];
  userViewLabel: string;
  onUserViewChange: (e) => void;
}

const ProductKAMSDropdownGroup: React.FC<ProductKAMSDropdownGroupProps> = props => {
  const {
    brand,
    brandChoices,
    brandLabel,
    brandDisabled,
    onBrandChange,
    userView,
    userViewChoices,
    userViewLabel,
    onUserViewChange
  } = props;

  const { dropdown, dropdownWrapper } = useStyles(props);
  const intl = useIntl();

  return (
    <div className={dropdownWrapper}>
      <SingleAutocompleteSelectField
        idInputTxt="viewAsTxt"
        label={intl.formatMessage({
          defaultMessage: "View as"
        })}
        className={dropdown}
        name="userViewDropdown"
        displayValue={userViewLabel}
        choices={userViewChoices}
        value={userView}
        onChange={onUserViewChange}
      />
      {brandLabel ? (
        <SingleAutocompleteSelectField
          idInputTxt="sellerTxt"
          label={intl.formatMessage({
            defaultMessage: "Seller (Brand)*"
          })}
          className={dropdown}
          name="brandDropdown"
          displayValue={brandLabel}
          choices={brandChoices}
          value={brand}
          onChange={onBrandChange}
          disabled={brandDisabled}
        />
      ) : (
        <SingleAutocompleteSelectField
          idInputTxt="sellerTxt"
          label={intl.formatMessage({
            defaultMessage: "Seller (Brand)*"
          })}
          className={dropdown}
          name="brandDropdown"
          displayValue={""}
          choices={[]}
          value={""}
          onChange={onBrandChange}
          disabled
        />
      )}
    </div>
  );
};

export default ProductKAMSDropdownGroup;
